import React from 'react';
import '../Details.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";
import BarChart from './BarChart';
import { useEffect, useState,useRef } from 'react';
function UsageData ({periodSelection}) {
const pageTitle = "UsageData"

const [chartProperties, setChartProperties] = useState({
      options: {
        chart: {
          id: "basic-bar"
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        }
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }
      ]
    } );

  return (
    <div className="details-container-page">
     <BarChart title="A Chart5"  height={600} periodSelection={periodSelection}  hasAdvancedOptions={true}/>
    </div>
  );
}

export default UsageData  ;
